import {omneticApi} from '@dms/api/base';
import {
  GetPhotoSettingsApiResponse,
  GetPhotoSettingsApiArg,
  UpdatePhotoSettingsApiResponse,
  UpdatePhotoSettingsApiArg,
} from '@dms/api/shared';

export const publishingPlatformPhotosSettingsApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getPhotoSettings: build.query<GetPhotoSettingsApiResponse, GetPhotoSettingsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v2/sales/publishing/platform/${queryArg.platformCode}/settings/photo`,
        params: queryArg.params,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'photoSettings', id: queryArg.platformCode},
      ],
    }),
    updatePhotoSettings: build.mutation<UpdatePhotoSettingsApiResponse, UpdatePhotoSettingsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v2/sales/publishing/platform/${queryArg.platformCode}/settings/photo`,
        method: 'PUT',
        body: queryArg.updatePlatformPhotoSettingsRequestBody,
        params: queryArg.params,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'photoSettings', id: queryArg.platformCode},
      ],
    }),
  }),
});

export const {useGetPhotoSettingsQuery, useUpdatePhotoSettingsMutation} =
  publishingPlatformPhotosSettingsApi;
